module.exports = __webpack_public_path__ + "img/fig7.1.af7cb1b2.png";